<template lang="pug">
  .bumper-set-breakdown-drawer
    Drawer.bumper-set-breakdown(v-if="overlay === `bumper-set-breakdown-${buyRequest.productId}`" :title="'Choose Set Breakdown for ' + product.name" @hide="closeBumperDrawer")
      bumper-selector(:buyRequest="buyRequest" @plateSetValid="handlePlateSet")
      rhpa-footer(
        :buyRequest="buyRequest"
        :disabled="!plateSetValid"
        :forceShowPrice="true"
        @addedToCart="closeBumperDrawer"
      )
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from 'vue'
import { useProductStore } from '@/js/stores/productStore'
import { useUIStore } from '@/js/stores/uiStore'
import type { BuyRequest } from '@/js/services/RogueTypes'

const BumperSelector = defineAsyncComponent(() => import(/* webpackChunkName: "bumper-set-breakdown" */'@/js/pages/product/components/bumper-set-breakdown/bumper-selector.vue'))
const RhpaFooter = defineAsyncComponent(() => import(/* webpackChunkName: "bumper-set-breakdown" */'@/js/components/rhpa/rhpa-footer.vue'))

const props = defineProps<{
  buyRequest: BuyRequest,
}>()

const plateSetValid = ref<boolean>(false)

const productStore = useProductStore()
const uiStore = useUIStore()

const overlay = computed(() => uiStore.overlay)
const products = computed(() => productStore.products)
const product = computed(() => {
  const buyRequest = props.buyRequest

  return products.value[buyRequest.productId]
})

function closeBumperDrawer() {
  props.buyRequest.qty = 0
  uiStore.hideOverlay()
  resetPlateOptions()
}

function resetPlateOptions() {
  props.buyRequest.metadata?.plateOpts?.forEach((child) => {
    child.qty = 0
  })
}

function handlePlateSet(val: boolean) {
  plateSetValid.value = val
}
</script>

<style lang="scss" scoped>
.bumper-set-breakdown .drawer-container .drawer-header h3 {
  margin-right: 40px;
}

.bumper-set-breakdown .drawer-container .drawer-body .rhpa-bottom {
  padding: 16px;
}
</style>
